
export default {
    name: 'm-loader',
};
